import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import { constants, links } from 'common/helpers'
import actions from 'redux/actions'
import { Message } from 'sb-react-intl'

import ConfirmModal from 'components/modals/ConfirmModal/ConfirmModal'

import messages from './messages'


const ShortPasswordModal = ({ name }) => {

  const close = useCallback(() => {
    actions.models.modals.close(name)
  }, [ name ])

  const changePassword = useCallback(() => {
    actions.models.router.push(links.profile.changePassword)
    close()
  }, [ close ])

  return (
    <ConfirmModal
      name={name}
      title={messages.title}
      id={name}
      confirmTitle={messages.confirmButton}
      cancelTitle={messages.cancelButton}
      onConfirm={changePassword}
      onCancel={close}
      withTextCancel
    >
      <Message text={messages.text} />
    </ConfirmModal>
  )
}

ShortPasswordModal.propTypes = {
  name: PropTypes.string,
}

ShortPasswordModal.defaultProps = {
  name: constants.modals.ShortPassword,
}

export default ShortPasswordModal
